import axios from 'axios';

const origin = `${process.env.VUE_APP_ORIGIN}`;
const url = `${origin}/api/chat-summaries`;

const getSummary = (chatId, language, daysNumber, force = false) =>
  axios.get(url, {
    params: { chat_id: chatId, language, days_number: daysNumber, force },
  });

export default { getSummary };
